var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('li',{staticClass:"page-item",class:{disabled: _vm.disabled, active: _vm.active}},[_c('a',{staticClass:"page-link",attrs:{"href":"#","type":"button","title":_vm.title},on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.$emit('click')}}},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }